var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4652_12682)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6682 19.8374H15.4402V27.6747H20.6682V19.8374Z",
    fill: "#B6DBFF",
    stroke: "#63A8F1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.07 27.6746H11.0384C10.0286 27.6746 9.20993 28.4911 9.20993 29.4983C9.20993 30.5055 10.0286 31.322 11.0384 31.322H25.07C26.0798 31.322 26.8984 30.5055 26.8984 29.4983C26.8984 28.4911 26.0798 27.6746 25.07 27.6746Z",
    fill: "#B6DBFF",
    stroke: "#63A8F1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3318 0.677979H2.66817C1.56859 0.677979 0.6772 1.57037 0.6772 2.6712V21.2068C0.6772 22.3076 1.56859 23.2 2.66817 23.2H33.3318C34.4314 23.2 35.3228 22.3076 35.3228 21.2068V2.6712C35.3228 1.57037 34.4314 0.677979 33.3318 0.677979Z",
    fill: "white",
    stroke: "#63A8F1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1422 18.834H2.85779C1.65348 18.834 0.6772 19.8114 0.6772 21.017C0.6772 22.2227 1.65348 23.2001 2.85779 23.2001H33.1422C34.3465 23.2001 35.3228 22.2227 35.3228 21.017C35.3228 19.8114 34.3465 18.834 33.1422 18.834Z",
    fill: "#E6F4FF",
    stroke: "#63A8F1",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5576 4.74585H16.1445C15.7111 4.74585 15.3725 5.09839 15.3725 5.51873V6.18314H20.3296C21.1287 6.18314 21.7788 6.83399 21.7788 7.63399V12.9492H25.5576C25.991 12.9492 26.3296 12.5967 26.3296 12.1764V5.51873C26.3296 5.08483 25.9774 4.74585 25.5576 4.74585Z",
    fill: "#63A8F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3296 6.87451H10.9165C10.4901 6.87451 10.1445 7.22054 10.1445 7.64739V14.3186C10.1445 14.7454 10.4901 15.0915 10.9165 15.0915H20.3296C20.7559 15.0915 21.1016 14.7454 21.1016 14.3186V7.64739C21.1016 7.22054 20.7559 6.87451 20.3296 6.87451Z",
    fill: "#B6DBFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4652_12682"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPc);
export default __webpack_public_path__ + "static/media/pc.c491072f33b391cab71e981eecaca2e2.svg";
export { ForwardRef as ReactComponent };